/**
 * WAV из отсчётов: один канал, 16 бит.
 *
 * Так уходит на сервер обрезанный звук панели. Перекодировать его в Opus
 * браузер умеет не везде, а WAV разбирают все. Пять секунд одного канала на
 * 48 кГц — около 490 КБ, в предел звука (512 КБ) укладывается.
 */
export function encodeWav(samples: Float32Array, rate: number): Uint8Array<ArrayBuffer> {
  const bytes = new Uint8Array(44 + samples.length * 2);
  const view = new DataView(bytes.buffer);
  const text = (at: number, value: string) => {
    for (let i = 0; i < value.length; i++) bytes[at + i] = value.charCodeAt(i);
  };
  text(0, "RIFF");
  view.setUint32(4, bytes.length - 8, true);
  text(8, "WAVE");
  text(12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, 1, true); // каналов
  view.setUint32(24, rate, true);
  view.setUint32(28, rate * 2, true); // байт в секунду
  view.setUint16(32, 2, true); // байт на отсчёт всех каналов
  view.setUint16(34, 16, true);
  text(36, "data");
  view.setUint32(40, samples.length * 2, true);
  for (let i = 0; i < samples.length; i++) {
    const sample = Math.max(-1, Math.min(1, samples[i]));
    view.setInt16(44 + i * 2, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true);
  }
  return bytes;
}
